module.exports = __webpack_public_path__ + "static/media/contact-page.fc0317c1.png";